export function initNavbarTheme() {
  const navbar = document.querySelector('.navbar_container');
  const sections = Array.from(document.querySelectorAll('[theme]'));

  if (!navbar || !sections.length) return;

  let observer;

  const updateNavbarTheme = () => {
    const probeY = navbar.getBoundingClientRect().height / 2;

    const activeSection = sections.find((section) => {
      const rect = section.getBoundingClientRect();
      return rect.top <= probeY && rect.bottom >= probeY;
    });

    navbar.classList.toggle(
      'is-on-light',
      activeSection?.getAttribute('theme') === 'light'
    );
  };

  const createObserver = () => {
    if (observer) observer.disconnect();

    const probeY = Math.round(navbar.getBoundingClientRect().height / 2);
    const bottomMargin = Math.max(window.innerHeight - probeY - 1, 0);

    observer = new IntersectionObserver(
      () => {
        updateNavbarTheme();
      },
      {
        root: null,
        rootMargin: `-${probeY}px 0px -${bottomMargin}px 0px`,
        threshold: 0
      }
    );

    sections.forEach((section) => observer.observe(section));
  };

  createObserver();
  updateNavbarTheme();

  window.addEventListener('resize', () => {
    createObserver();
    updateNavbarTheme();
  });
}
